import { Report } from '@activity/report'
import { NativeRequest } from 'onemt-sdk-native'

let $report:
  | ((
      name: string,
      body?: { [key: string]: unknown },
      timeout?: number
    ) => unknown)
  | null = null

export const createReport = async (
  nickName?: unknown,
  playerId?: unknown,
  serverId?: unknown,
  zoneId?: unknown
) => {
  const inSDK = window.inSDK
  const appid = window.appId
  const eventid = window.eventid
  const sdkConfig = window.sdkConfig
  let userInfo = window.userInfo
  if (inSDK) {
    try {
      const _gamePlayer = await NativeRequest<GamePlayer>(
        'getGamePlayer',
        { encode: true },
        5000
      )
      userInfo.serverId = _gamePlayer.serverId
      userInfo.playerId = _gamePlayer.playerId
      if (_gamePlayer.zoneId) {
        userInfo.zoneId = _gamePlayer.zoneId
      }
      // eslint-disable-next-line no-empty
    } catch (_) {}
  }

  try {
    if ($report == null) {
      const _report = Report.create({
        appid,
        platform: sdkConfig.platform,
        lang: userInfo.lang,
        userid: userInfo.userId,
        serverid: userInfo.serverId,
        region_id: String(userInfo.zoneId),
        gameuid: userInfo.playerId,
        version: process.env.pkgVersion || '',
        env: process.env.ENV as 'production' | 'development' | 'beta',
        timeout: 5000,
      })
      $report = (
        name: string,
        body?: { [key: string]: unknown },
        timeout?: number
      ) =>
        _report({
          name,
          timeout,
          cxt: Object.assign(
            {
              eventid,
              nickName: nickName || '',
              playerId: playerId || '',
              kid: serverId || '',
              region_id: zoneId || '',
            },
            body
          ),
        })
    }
    // eslint-disable-next-line no-empty
  } catch (_) {}
}

export default (() => $report) as () => typeof $report
